// Language toggle: top-right pill, cycles through the configured languages.
import { t, getLanguage, getLanguages, setLanguage, onLanguageChange } from '../i18n/index.js';
import { el } from '../debug/controls.js';
import { ICON_GLOBE } from './icons.js';

export function createLangToggle(app) {
  const code = el('span', { class: 'lang__code' });
  const root = el('button', { class: 'lang', type: 'button' }, [code]);
  root.insertAdjacentHTML('afterbegin', ICON_GLOBE);

  const render = () => {
    code.textContent = t('lang.code');
    root.setAttribute('aria-label', `Language: ${t('lang.name')}`);
  };
  render();
  onLanguageChange(render);

  root.addEventListener('pointerdown', () => root.classList.add('is-pressed'));
  for (const type of ['pointerup', 'pointercancel', 'pointerleave']) {
    root.addEventListener(type, () => root.classList.remove('is-pressed'));
  }
  root.addEventListener('click', () => {
    const langs = getLanguages();
    const next = langs[(langs.indexOf(getLanguage()) + 1) % langs.length];
    setLanguage(next);
  });

  app.append(root);
  return { root };
}
